import type { ExtraCostsPriceBreakdownPricingValues } from "@slfinrtl/ui-bff-routes"
import type { CheckboxFieldProps } from "../../../form/checkbox/CheckboxField"
import type { InputFieldProps } from "../../../form/input/InputField"
import type { ExtraCostsPriceSelectorFieldProps } from "./components/ExtraCostsPriceBreakdownPriceSelectorField"

export interface ExtraCostsPriceBreakdownPricingFields {
	extraCosts: ExtraCostsPriceSelectorFieldProps
	extraCostsVehicleType: { name: string }
	minimumPrice: InputFieldProps
	purchasePrice: InputFieldProps
	vatDeductible: CheckboxFieldProps | undefined
	vehiclePrice: InputFieldProps
}

type FieldName = keyof ExtraCostsPriceBreakdownPricingValues

const minimumPriceName: FieldName = "minimumPrice"
const purchasePriceName: FieldName = "purchasePrice"
const vehiclePriceName: FieldName = "vehiclePrice"
const vatDeductibleName: FieldName = "vatDeductible"
const extraCostsName: FieldName = "selectedExtraCostIds"
const extraCostsVehicleTypeName: FieldName = "extraCostsVehicleType"

export const extraCostsPricingFieldNames = {
	extraCostsName,
	extraCostsVehicleTypeName,
	minimumPriceName,
	purchasePriceName,
	vatDeductibleName,
	vehiclePriceName,
}
